/**
 * הגדרת גרסת סשן גלובלית
 * כל שינוי של המספר הזה יגרום לכל הטוקנים הישנים להיות לא תקפים (כולם יתנתקו)
 * 
 * חשוב: המספר הזה חייב להתאים למה שנמצא ב-server/config/sessionConfig.js
 */
export const CURRENT_SESSION_VERSION = 2;
